import { createEnv } from '@t3-oss/env-core'
import { z } from 'zod/v4'

import { cmsEnv } from '@package/cms/env'
import { sdkEnv } from '@package/sdk/env'
import { utilsEnv } from '@helper/utils/env'

export function authEnv() {
  return createEnv({
    extends: [utilsEnv(), cmsEnv(), sdkEnv()],
    server: {
      AUTH_SECRET: z.string().min(1),
      EXTRA_TRUSTED_ORIGINS: z.string().optional(),
      PIN_ENCRYPTION_KEY: z.string().min(1),
      GOOGLE_CLIENT_ID: z.string().min(1),
      GOOGLE_CLIENT_SECRET: z.string().min(1),
      NODE_ENV: z.enum(['development', 'production']).optional(),
      MARKETING_CLIENT_ID: z.string().min(1),
      CONTENT_CLIENT_ID: z.string().min(1),
      ADMIN_CLIENT_ID: z.string().min(1),
      PARTNER_CLIENT_ID: z.string().min(1),
      SCHOOL_CLIENT_ID: z.string().min(1),
      WEB_CLIENT_ID: z.string().min(1),
    },
    clientPrefix: 'NEXT_PUBLIC',
    client: {
      NEXT_PUBLIC_PROD_ENV: z.enum(['development', 'production', 'staging']).optional(),
    },
    runtimeEnv: process.env,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
    skipValidation:
      !!process.env.CI ||
      process.env.npm_lifecycle_event === 'lint' ||
      typeof (globalThis as any).window !== 'undefined', // Skip in browser
  })
}
